module.exports = __webpack_public_path__ + "img/horizontal_3_1_r_5012.8f3c97b2.png";